import { put, call } from 'redux-saga/effects';

import { Types } from './actions';

import ScheduleRepository from '@/domain/repositories/ScheduleRepository';
import ScheduleDataRepository from '@/data/repositories/ScheduleDataRepository';

export default function* execute(action: any): any {
  try {
    const { periodId } = action;
    yield put({ type: Types.GET_SCHEDULE_RESUME_REQUEST });
    const scheduleRepository: ScheduleRepository = new ScheduleDataRepository();
    const examSstragglesResponse = yield call(
      scheduleRepository.getScheduleResumeHome,
      periodId
    );

    if (!examSstragglesResponse) {
      yield put({ type: Types.GET_SCHEDULE_RESUME_FAILURE, error: true });
      return;
    }

    yield put({
      type: Types.GET_SCHEDULE_RESUME_SUCCESS,
      data: examSstragglesResponse
    });
  } catch (error) {
    yield put({
      type: Types.GET_SCHEDULE_RESUME_FAILURE,
      error: 'Ocurrió un error al momento de solicitar los datos.'
    });
  }
}
